import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { NearbySchoolFilter } from '../../../../models/Filter';
import { NearbySchoolButtonFilterView } from '../../desktop/nearby_school/NearbySchoolButtonFilterView';

interface IDistrictFilter {
    filter: NearbySchoolFilter;
    handleChange: (filter: NearbySchoolFilter) => void;
}

export const MobileDistrictFilterButtonView: React.FC<IDistrictFilter> = ({
    filter,
    handleChange
}) => {
    return (
        <MobileFilter2 filterTitle='Рядом'>
            <NearbySchoolButtonFilterView
                filter={filter}
                handleChange={handleChange}
            />
        </MobileFilter2>
    );
};
